<div
  class="status-icon-ellipsis"
  [ngClass]="{
    none: state() === ProgressionStateTypeEnum.None,
    current: state() === ProgressionStateTypeEnum.Current,
  }">
  <orbit-fa-icon class="status-icon" [iconName]="iconName()" />
</div>
